//@flow
import React from "react";

export function ButtonInStore() {
  return (
    <button className="in-store" disabled>
      IN_STORE_ONLY
    </button>
  );
}
